import React from 'react';

import {
  Navigate,
  Outlet,
  Route,
  Routes,
} from 'react-router-dom';

import ProtectedRoute
  from './ProtectedRoute';

import UpdateNoticeShellPage
  from '../features/update-notice/pages/UpdateNoticeShellPage';

import UpdateNoticeListPage
  from '../features/update-notice/pages/UpdateNoticeListPage';

import UpdateNoticeDetailPage
  from '../features/update-notice/pages/UpdateNoticeDetailPage';

import UpdateNoticeAdminPage
  from '../features/update-notice/pages/UpdateNoticeAdminPage';

import UpdateNoticeEditorPage
  from '../features/update-notice/pages/UpdateNoticeEditorPage';

import {
  ROUTES,
  UPDATE_NOTICE_PATHS,
} from '../config/routes';


function UpdateNoticeAccessLayout() {
  return (
    <Outlet />
  );
}


export default function UpdateNoticeRoute() {
  return (
    <Routes>
      <Route
        element={
          <UpdateNoticeAccessLayout />
        }
      >
        <Route
          element={
            <UpdateNoticeShellPage />
          }
        >
          <Route
            index
            element={
              <UpdateNoticeListPage />
            }
          />

          <Route
            path={UPDATE_NOTICE_PATHS.detail}
            element={
              <UpdateNoticeDetailPage />
            }
          />
        </Route>


        <Route
          element={
            <ProtectedRoute />
          }
        >
          <Route
            path={UPDATE_NOTICE_PATHS.admin}
            element={
              <UpdateNoticeAdminPage />
            }
          />

          <Route
            path={UPDATE_NOTICE_PATHS.create}
            element={
              <UpdateNoticeEditorPage />
            }
          />

          <Route
            path={UPDATE_NOTICE_PATHS.edit}
            element={
              <UpdateNoticeEditorPage />
            }
          />
        </Route>
      </Route>


      <Route
        path="*"
        element={
          <Navigate
            to={
              ROUTES.updatenotices
            }
            replace
          />
        }
      />
    </Routes>
  );
}